import { render } from "./SurveyPage03.vue?vue&type=template&id=9dfb4bb0&scoped=true"
const script = {}

import "./SurveyPage03.vue?vue&type=style&index=0&id=9dfb4bb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dfb4bb0"]])

export default __exports__